import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Footer from './components/Common/Footer';

// Components
import Login from './components/Auth/Login';
import Dashboard from './components/Admin/Dashboard';
import LiveResults from './components/Public/LiveResults';
import Nominations from './components/Public/Nominations';
import CandidateDetails from './components/Public/CandidateDetails';
import BiharElectionNews from './components/Public/BiharElectionNews';
import VoterCertificate from './components/Public/VoterCertificate';
import PollPercentage from './components/Public/PollPercentage';
import PollingPercentage from './components/Public/PollingPercentage';
import VoteCounting from './components/Public/VoteCounting';
import WinnerRunnerUpPage from './components/Public/WinnerRunnerUpPage';

// ✅ Voter Survey Components
import VoterSurvey from './components/Public/VoterSurvey';
import SurveyThankYou from './components/Public/SurveyThankYou';
import SurveyResults from './components/Public/SurveyResults';
import SurveyAnalytics from './components/Public/SurveyAnalytics';

// Security - Only Session Timeout
import SessionTimeout from './components/Security/SessionTimeout';
import ProtectedRoute from './components/Auth/ProtectedRoute';

// Blog Components
import BlogList from './components/Blog/BlogList';
import BlogDetail from './components/Blog/BlogDetail';

// News Page
import NewsPage from './pages/News';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Disclaimer from './pages/Disclaimer';

// Styles
import './App.css';

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <BrowserRouter>
      {/* Session Timeout Security */}
      {/* <SessionTimeout /> */}

      <Routes>
        {/* ==================== PUBLIC ROUTES ==================== */}
        {/* Home & Results */}
        <Route path="/" element={<LiveResults />} />
        <Route path="/results" element={<LiveResults />} />

        {/* Elections & Nominations */}
        <Route path="/nominations" element={<Nominations />} />
        <Route path="/candidate/:id" element={<CandidateDetails />} />

        {/* ✅ VOTER SURVEY ROUTES */}
        <Route path="/survey" element={<VoterSurvey />} />
        <Route path="/survey/thank-you" element={<SurveyThankYou />} />
        <Route path="/survey/results" element={<SurveyResults />} />
        <Route path="/survey/analytics" element={<SurveyAnalytics />} />

        {/* Voter Certificate */}
        <Route path="/voter-certificate" element={<VoterCertificate />} />

        {/* News Routes */}
        <Route path="/news" element={<NewsPage />} />
        <Route path="/bihar-election-news" element={<BiharElectionNews />} />

        {/* Blog Routes - Public */}
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/voter-awareness" element={<Navigate to="/blog" replace />} />
        <Route path="/poll-percentage" element={<PollPercentage />} />
        <Route path="/polling-percentage" element={<PollingPercentage />} />
        <Route path="/vote-counting" element={<VoteCounting />} />
        <Route path="/winners-runnerup" element={<WinnerRunnerUpPage />} />

        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />

        {/* ==================== AUTHENTICATION ROUTES ==================== */}
        <Route path="/login" element={<Login />} />

        {/* ==================== ADMIN ROUTES - PROTECTED ==================== */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* ==================== CATCH ALL ==================== */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
